import { render, staticRenderFns } from "./CustomEcWidget.vue?vue&type=template&id=c6d5d850&scoped=true&"
import script from "./CustomEcWidget.vue?vue&type=script&lang=js&"
export * from "./CustomEcWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d5d850",
  null
  
)

export default component.exports